import React, {useMemo} from "react"
import {KlassDropdownProps} from "../Select"
import {KlassDropdown} from "../inputs"

type Props = Partial<KlassDropdownProps> & {}

export const CLOCK_STATUSES = [
    "On Clock",
    "Off Clock",
    "Off Clock-FA Requirements/Docs",
    "Off Clock-Withdrawal",
    "Off Clock-Grad Requirements",
    "Off Clock-Past Due Payments",
    "Off Clock-Campus",
    "Off Clock-Over Attending",
    "Off Clock-Kit Receipts",
    "Off Clock-Near TDLR Max",
    "Off Clock-SAP"
]

const ClockStatusSelect: React.FC<Props> = ({value, ...props}) => {
    const options = useMemo(() => CLOCK_STATUSES.map((value) => ({id: value, name: value})), [])

    return (
        <KlassDropdown
            {...props}
            options={options}
            valueKey="id"
            labelKey="name"
            value={
                typeof value === "string"
                    ? options.find((option) => option.id === value)
                    : Array.isArray(value) && typeof value[0] === "string"
                    ? options.filter((option) => value.includes(option.id))
                    : value
            }
        />
    )
}

export default ClockStatusSelect
